import React, { useEffect, useState } from 'react';
import { LockSimpleIcon } from '@phosphor-icons/react/ssr';
import { sessionManager } from '../../utils/sessionManager';
import { Modal } from '../Modal';
import { Button } from '../Button';
import './SessionExpiredModal.css';

export const SessionExpiredModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Subscribe to session expiration events
    const unsubscribe = sessionManager.subscribe(() => {
      setIsOpen(true);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleLoginAgain = () => {
    setIsOpen(false);
    sessionManager.resetSession();
    // Clear any remaining tokens
    if (typeof window !== 'undefined') {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.href = '/login';
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}} // Prevent closing by clicking outside
      title=""
      className="session-expired-modal"
    >
      <div className="session-expired-modal__content">
        <div className="session-expired-modal__icon">
          <span className="session-expired-modal__emoji">
            <LockSimpleIcon size={40} weight="fill" color="white" />
          </span>
        </div>
        <h2 className="session-expired-modal__title">Session Expired</h2>
        <p className="session-expired-modal__message">
          Your session has expired. Please log in again to continue.
        </p>
        <Button
          variant="primary"
          onClick={handleLoginAgain}
          fullWidth
          size="large"
        >
          Log In Again
        </Button>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal;
